/*import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import add from '../../../img/add.svg';
import details from '../../../img/details.svg';
import sortasc from '../../../img/sort-asc.svg';
import sortdesc from '../../../img/sort-desc.svg';
import del from '../../../img/del.svg';



export default class EventParticipantScreen extends React.Component {

    constructor(props) {
        super(props);

        var eventid = null
        var sortField = null
        var sortOrder = null
        var pageCount = 0
        var event = null
        
        const args = props.args === undefined ? {} : props.args

        if (args.event != undefined) {
            event = args.event
        }

        if (args.eventid !== undefined) {
            eventid = args.eventid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {args: args,
                      pageLimit: 25, 
                      pageCount: pageCount,   
                      nameCriteria: "",
                      prevNameCriteria:"",
                      eventid: eventid,
                      event: event,
                      sortField: sortField, 
                      sortOrder: sortOrder,
                      participants: []};

              

        this.nameSearch = this.nameSearch.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)

        setTimeout(this.nameSearch, 2000);
    }

    async componentDidMount() {
        this.getDataWithCritera()
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }


    getDataWithCritera() {

        var parameters = {}

        if (this.state.eventid) {
            parameters.eventid = this.state.eventid
        } 

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/event/participant', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({participants: res.data})
        })    
        .catch(error=>console.log(error))
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break 
            case "birthdateCaption" :
                if (currentField === "birthdate") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "birthdate"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    openBeneficiar(id) {
        this.props.navigate("beneficiary", {caller: "event-participant", callargs: this.state.args, beneficiary: id})
    }

    selectParticipant() {
        
        this.props.navigate("event-participant-select", {caller: "event-participant", callargs: this.state.args, eventid: this.state.eventid, event: this.state.event}) 
    } 

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    deleteParticipant(id) {
        BaseApi.delete('/event/participant', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: id}, withCredentials: true})
        .then(res => {
            this.getDataWithCritera()
        })    
        .catch(error=>console.log(error))
    }
    
    renderParticipant(participant) {
    
        return (
            <div class="row" style={{"height" : "50px"}}>
                    <div class="col-4 text-left border border-white" style={{"background-color" : "#eee"}}>{participant.name}</div>
                    <div class="col-3 text-left border border-white" style={{"background-color" : "#eee"}}>{participant.birthdate}</div>
                    <div class="col-1 border border-white"  style={{"background-color" : "#eee"}} onClick={()=>this.openBeneficiar(participant.beneficiaryid)}><img src={details} height="16" width="16"/></div>
                    <div class="col-1 border border-white"  style={{"background-color" : "#eee"}} onClick={()=>this.deleteParticipant(participant.id)}><img src={del} height="16" width="16"/></div>
            </div>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Участники события"}/>
                <div class="mt-5 col-md-4">
                    <form title="Фильтр">
                        <div class="form-group">
                            <label for="name"> Имя:</label>
                            <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                        </div>
                    </form>
                </div>
                <div class="row" style={{"height" : "50px"}}>
                    <div class= "col-md-4 offset-md-8 float-left">
                        <button class="btn btn-primary" onClick={()=>{this.prevPage()}}>Предыдущие</button> 
                        <button class="btn btn-primary" style={{"margin-left" : "10px"}} onClick={()=>{this.nextPage()}}>Следующие</button> 
                    </div>
                </div>
                <div class="row" style={{"height" : "50px"}}>
                    <div class="col-4 text-left border border-white"
                         id="nameCaption"    
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                            ФИО
                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-3 text-left border border-white"
                         id="birthdateCaption" 
                         style={{"background-color" : "#0ee"}}
                         onClick={this.sortClicked}>
                         Дата рождения
                         {this.isFieldSortedDesc("birthdate") && <img src={sortdesc} height="16" width="16"/>}
                         {this.isFieldSortedAsc("birthdate") && <img src={sortasc} height="16" width="16"/>}
                    </div>
                    <div class="col-1 border border-white"
                         id="detailCaptuon" 
                         style={{"background-color" : "#0ee"}}
                         onClick={()=>{this.selectParticipant()}}>
                         <img src={add} height="16" width="16"/>
                    </div>    
                    <div class="col-1 border border-white"
                         id="detailCaptuon" 
                         style={{"background-color" : "#0ee"}}>
                    </div>      
                </div>    
                {this.state.participants.map((value, index) => this.renderParticipant(value))}
            
            </div> 
        )
    }
} */

import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import details from '../../../img/details.svg';
import sortasc from '../../../img/sort-asc.svg';
import sortdesc from '../../../img/sort-desc.svg';
import add from '../../../img/add.svg';
import del from '../../../img/del.svg';

export default class EventParticipantScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
            args,
            pageLimit: 25,
            pageCount: (args.pageCount !== undefined ? args.pageCount : 0),
            sortField: (args.sortField !== undefined ? args.sortField : null),
            sortOrder: (args.sortOrder !== undefined ? args.sortOrder : null),
            nameCriteria: "",
            prevNameCriteria: "",
            eventid: args.eventid,
            event: args.event,
            participants: []
        };

        this.nameSearch = this.nameSearch.bind(this);
        this.sortClicked = this.sortClicked.bind(this);

        setTimeout(this.nameSearch, 2000);
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        const p = {
            limit: this.state.pageLimit,
            offset: this.state.pageLimit * this.state.pageCount
        };

        if (this.state.eventid) p.eventid = this.state.eventid;
        if (this.state.nameCriteria) p.name = this.state.nameCriteria;
        if (this.state.sortField) p.orderby = this.state.sortField;
        if (this.state.sortOrder) p.sortorder = this.state.sortOrder;

        BaseApi.get('/event/participant', {
            headers: {
                'Content-Type': 'application/json',
                'SESSIONID': sessionStorage.getItem("session")
            },
            params: p,
            withCredentials: true
        })
        .then(res => this.setState({ participants: res.data }))
        .catch(console.log);
    }

    nameCriteriaChange = (e) => {
        this.setState({ nameCriteria: e.target.value });
    };

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            this.setState(
                { prevNameCriteria: this.state.nameCriteria, pageCount: 0 },
                this.getData
            );
        }
        setTimeout(this.nameSearch, 2000);
    }

    nextPage = () => {
        this.setState({ pageCount: this.state.pageCount + 1 }, this.getData);
    };

    prevPage = () => {
        if (this.state.pageCount > 0) {
            this.setState({ pageCount: this.state.pageCount - 1 }, this.getData);
        }
    };

    sortClicked(e) {
        const field = e.target.id;
        let { sortField, sortOrder } = this.state;

        if (sortField === field) {
            sortOrder = sortOrder === "desc" ? "asc" : "desc";
        } else {
            sortField = field;
            sortOrder = "asc";
        }

        this.setState({ sortField, sortOrder, pageCount: 0 }, this.getData);
    }

    isDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc";
    }
    isAsc(field) {
        return this.state.sortField === field && this.state.sortOrder === "asc";
    }

    openBeneficiary(id) {
        this.props.navigate("beneficiary", {
            caller: "event-participant",
            callargs: this.state.args,
            beneficiary: id
        });
    }

    selectParticipant = () => {
        this.props.navigate("event-participant-select", {
            caller: "event-participant",
            callargs: this.state.args,
            eventid: this.state.eventid,
            event: this.state.event
        });
    };

    deleteParticipant(id) {
        BaseApi.delete('/event/participant', {
            headers: {
                'Content-Type': 'application/json',
                'SESSIONID': sessionStorage.getItem("session")
            },
            params: { id },
            withCredentials: true
        })
        .then(() => this.getData())
        .catch(console.log);
    }

    renderParticipant(participant) {
        return(
            <tr
                key={participant.id}
                className="table-row-clickable"
                onClick={() => this.openBeneficiary(participant.beneficiaryid)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>{participant.name}</td>
                <td>{participant.yearofbirth}</td>

                <td className="text-center">
                    <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={(e) => {
                            e.stopPropagation();          // важно: не триггерить клик по строке
                            this.deleteParticipant(participant.id);
                        }}
                    >
                        <img src={del} height="14" />
                    </button>
                </td>
            </tr>
        )
         
    }

    render() {
        const { participants } = this.state;

        return (
            <div className="container">
                <ScreenCaption 
                    goback={this.props.goback} 
                    args={this.state.args}
                    caption="Участники события"
                />

                {/* Фильтр */}
                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>
                            
                                <div className="mb-3">
                                        <label className="form-label">Имя</label>
                                    <input
                                        type="text"
                                        value={this.state.nameCriteria}
                                        onChange={this.nameCriteriaChange}
                                        className="form-control"
                                    />
                                </div>
                                   
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button className="btn btn-primary d-flex align-items-center" onClick={this.selectParticipant}>
                                Добавить участников
                            </button>
                        </div>

                        {/* Пагинация */}
                        <div>
                            <button className="btn btn-outline-secondary btn-sm me-2" onClick={this.prevPage}>Предыдущие</button>
                            <button className="btn btn-outline-secondary btn-sm" onClick={this.nextPage}>Следующие</button>
                        </div>
                    </div>
                </div>
            
                {/* Таблица */}
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th
                                            id="name"
                                            onClick={this.sortClicked}
                                            className="text-start"
                                            style={{ cursor: "pointer" }}
                                        >
                                            ФИО
                                            {this.isDesc("name") && <img src={sortdesc} height="14" className="ms-1" />}
                                            {this.isAsc("name") && <img src={sortasc} height="14" className="ms-1" />}
                                        </th>

                                        <th
                                            id="yearofbirth"
                                            onClick={this.sortClicked}
                                            className="text-start"
                                            style={{ cursor: "pointer" }}
                                        >
                                            Год рождения
                                            {this.isDesc("yearofbirth") && <img src={sortdesc} height="14" className="ms-1" />}
                                            {this.isAsc("yearofbirth") && <img src={sortasc} height="14" className="ms-1" />}
                                        </th>

                                        {/*<th className="text-center" style={{ width: "40px" }}>Открыть</th>*/}
                                        <th className="text-center" style={{ width: "40px" }}>Удалить</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {participants.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center text-muted py-3">
                                                Участники не найдены
                                            </td>
                                        </tr>
                                    )}
                                    {participants.map(p => this.renderParticipant(p))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/event-participants.js